export const environment = {
  production: false,
  apiUrl: 'https://stgamlpadmin-api.rikkeidigital.asia',
  googleMapKey: 'AIzaSyCpVhQiwAllg1RAFaxMWSpQruuGARy0Y1k'
};
